export const MOBILE_WIDTH = 640;
export const MOBILE_SCREEN_WIDTH = 360;
export const PC_WIDTH = 1200;
export const PC_SCREEN_WIDTH = 1920;

export const MOBILE_PX_RATIO = 100 / MOBILE_WIDTH;
